import type { ThingCard } from "src/api";
import { Swatch } from "../unitRows";
import { holdingTone } from "../unitTone";
import { Row } from "./styles";

/**
 * What the square's occupant is standing on (`ThingCard.under`).
 *
 * No caption: the swatch names the material and the line says the rest, which
 * is the readouts' ruling wherever material is drawn.
 */
export function Under({ row }: { row: NonNullable<ThingCard["under"]> }) {
  return (
    <Row className="start" data-testid="under-row">
      <Swatch style={{ background: holdingTone(row.swatch) }} />
      {row.text}
    </Row>
  );
}
